import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
//import StorageService from 'services/StorageService/service';
import { addClass } from 'utils/index';
import style from './style.scss'; //NOSONAR

const Curtain = (props) => {
    const {content} = props;

    if(!content) return '';

    /*const [value, setValue] = useState("");
   const [valid, setValid] = useState(true);*/

    useEffect(() => {
        addClass(document.body, 'body-curtain');
    });

    /*const validateForm = (event) => {
        
        event.preventDefault();

        event.currentTarget.focus();

        if(value === 'MOVILIDADREDUCIDA') {
            StorageService.setItem('MOVILIDADREDUCIDA', true);
            if(window && window.location) {
                window.location.reload();
            }

        } else {
            setValid(false);
        }

    };*/

    return (
        <div className="curtain-page">
            <i className="curtain-logo jumbo-icon-logo" />
            <div className='curtain-container'>
                <div className={'curtain-description'}>
                    <div className="curtain-description-text" dangerouslySetInnerHTML={{ __html: content.description.replace(/\r/g, '<br />') }} />
                    {content.attach && <a href={content.attach} className={'curtain-link'}>Ver disponibilidad de locales abiertos</a>}
                </div>

                {/*<form className={'curtain-description-form'}>
                    <p>Si recibiste el código para personas con <br/><strong>movilidad reducida ingresalo aquí:</strong></p>
                    <input className='curtain-input' type="text" onChange={event => setValue(event.target.value.toUpperCase())} onFocus={()=>setValid(true)}/>
                    <button type="submit" className={'curtain-link'} onClick={event=>validateForm(event)}>Enviar</button>
                    {!valid && <div className="alert-input">*El código no es válido</div>}
                </form>*/}
            </div>
        </div>
    )
}

Curtain.propTypes = {
    content: PropTypes.object
};

export default Curtain;
